import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { colorText } from '@/utils/palette';
import { PaperclipIcon } from '@/shared/dynamicImports';
import { Button } from '@/shared/components/Button';

export const FileInputField = ({ onChange, name, value = null, label, error, helperText, useIcon = false, accept }) => {
  const [file, setFile] = useState(value);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    setFile({ file: selectedFile, name: selectedFile.name });
    onChange({ file: selectedFile, name: selectedFile.name });
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setFile(null);
    onChange(null);
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  return (
    <>
      {label && <Label error={error}>{label}</Label>}
      <>
        {useIcon ? (
          <Button
            variant='primary'
            type='button'
            onClick={handleButtonClick}
          >
            <PaperclipIcon />
          </Button>
        ) : (
          <Button
            variant='primary'
            type='button'
            onClick={handleButtonClick}
          >
            Choose the file
            {file && (
              <>
                <span style={{ color: 'white' }}>&nbsp;|&nbsp;{file.name}</span>
                <RemoveButton
                  type='button'
                  onClick={handleRemove}
                >
                  Remove
                </RemoveButton>
              </>
            )}
          </Button>
        )}
        <input
          type='file'
          name={name}
          id={name}
          onChange={handleChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept={accept}
        />
      </>
      {helperText && <HelperText>{helperText}</HelperText>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

export default FileInputField;

// region STYLES
const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const RemoveButton = styled.button`
  margin-left: 10px;
  background-color: transparent;
  color: red;
  border: none;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;
// endregion
